export function getPassportExperienceIds(tags: Array<App.OfferTag>): Array<string> {
  return Array.from(new Set(tags.flatMap(tag =>
    tag.assignments
      ?.filter(assignment => assignment.entityType === 'EXPERIENCE')
      .map(assignment => assignment.entityId) ?? [],
  )))
}
